import {
  EXPORT_SCHOOL,
  EXPORT_SCHOOL_FAILURE,
  EXPORT_SCHOOL_SUCCESS,
  EXPORT_STUDENT,
  EXPORT_STUDENT_FAILURE,
  EXPORT_STUDENT_SUCCESS,
  EXPORT_TEACHER,
  EXPORT_TEACHER_SUCCESS,
  EXPORT_TEACHER_FAILURE,
  RELOAD_SCHOOL_DETAIL
} from "../../Actions/types";

const initialState = {
  exportSchoolLoader: false,
  exportSchoolError: false,
  exportProductData: null,
  exportStudentLoader: false,
  exportStudentError: false,
  exportStudentData: null,
  exportTeacherLoader: false,
  exportTeacherError: false,
  exportTeacherData: null,
  reloadSchoolDetail: 1
};

function exportManagementReducer(state = initialState, action) {
  switch (action.type) {
    case EXPORT_SCHOOL:
      return { ...state, exportSchoolLoader: true };
    case EXPORT_SCHOOL_SUCCESS:
      return {
        ...state,
        exportSchoolData: action?.payload,
        exportSchoolLoader: false,
      };
    case EXPORT_SCHOOL_FAILURE:
      return {
        ...state,
        exportSchoolLoader: false,
        exportSchoolError: true,
      };

    case EXPORT_STUDENT:
      return { ...state, exportStudentLoader: true };
    case EXPORT_STUDENT_SUCCESS:
      return {
        ...state,
        exportStudentData: action?.payload,
        exportStudentLoader: false,
      };
    case EXPORT_STUDENT_FAILURE:
      return {
        ...state,
        exportStudentLoader: false,
        exportStudentError: true,
      };

    case EXPORT_TEACHER:
      return { ...state, exportTeacherLoader: true };
    case EXPORT_TEACHER_SUCCESS:
      return {
        ...state,
        exportTeacherData: action?.payload,
        exportTeacherLoader: false,
      };
    case EXPORT_TEACHER_FAILURE:
      return {
        ...state,
        exportTeacherLoader: false,
        exportTeacherError: true,
      };

    case RELOAD_SCHOOL_DETAIL:
      return {
        reloadSchoolDetail: action?.payload?.value
      }  

    default:
      return state;
  }
}

export default exportManagementReducer;
